import { BaseAction } from "./BaseAction";
export class StaticStateAction extends BaseAction {
    constructor(config, options) {
        super(options, config);
    }
    static busy() {
        return new StaticStateAction({
            triggerIsBusy: true,
        });
    }
    static active() {
        return new StaticStateAction({
            isActive: true,
        });
    }
    triggerImplementation() { }
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiU3RhdGljU3RhdGVBY3Rpb24uanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi9zcmMvbGliL2FjdGlvbnMvU3RhdGljU3RhdGVBY3Rpb24udHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUEsT0FBTyxFQUFpQixVQUFVLEVBQUUsTUFBTSxjQUFjLENBQUM7QUFLekQsTUFBTSxPQUFPLGlCQUFrQixTQUFRLFVBQVU7SUFDL0MsWUFBbUIsTUFBK0IsRUFBRSxPQUF1QjtRQUN6RSxLQUFLLENBQUMsT0FBTyxFQUFFLE1BQU0sQ0FBQyxDQUFDO0lBQ3pCLENBQUM7SUFFTSxNQUFNLENBQUMsSUFBSTtRQUNoQixPQUFPLElBQUksaUJBQWlCLENBQUM7WUFDM0IsYUFBYSxFQUFFLElBQUk7U0FDcEIsQ0FBQyxDQUFDO0lBQ0wsQ0FBQztJQUVNLE1BQU0sQ0FBQyxNQUFNO1FBQ2xCLE9BQU8sSUFBSSxpQkFBaUIsQ0FBQztZQUMzQixRQUFRLEVBQUUsSUFBSTtTQUNmLENBQUMsQ0FBQztJQUNMLENBQUM7SUFFUyxxQkFBcUIsS0FBVSxDQUFDO0NBQzNDIn0=